/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '../../../utils/format';

export const actions = {
  async fetch({}, payload) {
    return await http.get(`/psp/gtk/kp-lokakarya-rekap?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async getDetail({}, payload) {
    return await http.get(`/psp/gtk/kp-lokakarya-rekap/${payload.id}`).then(({ data }) => data);
  },

  update({}, payload) {
    return http.post(`/psp/gtk/kp-lokakarya-rekap/${payload.id}/save`, payload.params).then(({ data }) => data);
  },
};
